export { default } from './NotifyAvatar';
